import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrincipalComponent } from './principal/principal.component';
import { LandingComponent } from './landing/landing.component';
import { PersonaGuardService } from '../guards/persona-guard.service';
import { PersonaActualizadaGuard } from '../guards/persona-actualizada-guard.service';

const routes: Routes = [
  {
    path: 'principal',
    canActivate: [PersonaActualizadaGuard],
    component: PrincipalComponent,
  },
  {
    path: 'landing',
    canActivate: [PersonaGuardService, PersonaActualizadaGuard],
    component: LandingComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NavegacionRoutingModule {}
